import {
    APLICACAO_MODO_TELA,
    APLICACAO_AGUARDANDO,
    APLICACAO_LISTADA,
    APLICACAO_OPCOES,
    APLICACAO_AREAS,
    APLICACAO_HISTORICO
} from './aplicacaoActions';

const INITIAL_STATE = {
    modoTela: 'lista',
    registro: {},
    aguardando: false,
    lista: [],
    clientes: [],
    produtos: [],
    unidades: [],
    veiculos: [],
    status: [],
    tipos: [],
    formas_pagamento: [],
    areasCliente: [],
    historico: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case APLICACAO_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro
            };
        case APLICACAO_AGUARDANDO:
            return { ...state, aguardando: action.payload };
        case APLICACAO_LISTADA:
            return { ...state, lista: action.payload || [] };
        case APLICACAO_OPCOES:
            return { ...state, ...(action.payload || {}) };
        case APLICACAO_AREAS:
            return {
                ...state,
                areasCliente: action.payload || []
            };
        case APLICACAO_HISTORICO:
            return {
                ...state,
                historico: action.payload || []
            };
        default:
            return state;
    }
};
